<template>
  <div class="index">
    <input type="file" @change="load" ref="fileInput">
    <button class="button is-info" @click="save">СОХРАНИТЬ</button>
    <hr>
    <ul>
      <li v-for="file in files" :key="file.name">
        {{ file.filename }}: <a :href="filePath(file.filepath)" target="_blank">{{ filePath(file.filepath) }}</a>
        <button class="delete is-medium" @click="del(file.filename)"></button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      file: null,
      userMenu: []
    }
  },
  name: 'FilesStorage',
  methods: {
    ...mapActions(['loadFilesStorage', 'saveFile', 'delFile']),
    load (e) {
      this.file = e.target.files[0]
    },
    async save (e) {
      await this.saveFile(this.file)
      this.file = null
      this.$refs.fileInput.value = ''
    },
    async del (filename) {
      await this.delFile(filename)
    },
    filePath (path) {
      return `http://grottbjorn.com/${path}`
    }
  },
  computed: {
    ...mapState(['files'])
  },
  async created () {
    await this.loadFilesStorage()
    // this.userMenu = this.menu.main.filter(i => i.roles.includes(this.user.role))
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Files.vue?8ca75a2c